import * as React from 'react';
import { makeStyles } from '@material-ui/core';
import { blue } from '../theme/colors';
import { fontFamilies } from '../theme/text';
import clsx from 'clsx';

export interface TertiaryButtonProps {
  /** Button Text */
  text: string;
  /** Title of the button, shown on hover */
  title?: string;
  /** Set to true to show disabled state */
  deactive?: boolean;
  /** onClick handler */
  handleClick: (event?: React.MouseEvent<HTMLSpanElement, MouseEvent>) => void;
  /** custom styles class */
  className?: string;
  /** span or button component, defaults to span (original portal), use button for inherited button functionality (i.e. keyboard navigation) */
  component?: 'span' | 'button';
}

const useStyles = makeStyles({
  root: {
    fontFamily: fontFamilies.heading,
    fontWeight: 300,
    lineHeight: 1.45,
    fontSize: 11,
    color: blue[600],
    textTransform: 'uppercase',
    cursor: 'pointer'
  },
  button: {
    border: 'none',
    backgroundColor: 'transparent'
  }
});

/**
 * Tertiary Button. A text button intended to be embedded within other components such as tables.
 */
const TertiaryButton = ({
  text,
  title,
  deactive,
  handleClick,
  className,
  component
}: TertiaryButtonProps) => {
  const classes = useStyles();
  if (deactive) {
    return <div />;
  }
  return (
    <React.Fragment>
      {component && component == 'button' ? (
        <button
          type="button"
          className={clsx(classes.root, classes.button, className)}
          title={title}
          onClick={(event?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
            handleClick(event);
          }}
        >
          {text}
        </button>
      ) : (
        <span
          className={clsx(classes.root, className)}
          title={title}
          onClick={(event?: React.MouseEvent<HTMLSpanElement, MouseEvent>) => handleClick(event)}
        >
          {text}
        </span>
      )}
    </React.Fragment>
  );
};

export default TertiaryButton;
